import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import useDebounce from '../useDebounce';

const offsetScroll = 100;

export default (node: { current?: HTMLDivElement | null }, isWindow = false) => {
  const location = useLocation();
  const [isBottom, setIsBottom] = useState(false);
  const debouncedIsBottom = useDebounce(isBottom, 100);
  const element = isWindow ? window : node.current;

  const handleScroll = useCallback(() => {
    if (!node.current && !isWindow) return;

    const scrollTop = node.current && !isWindow ? node.current.scrollTop : window.scrollY;
    const scrollHeight =
      node.current && !isWindow ? node.current.scrollHeight : document.body.scrollHeight;
    const clientHeight = node.current && !isWindow ? node.current.clientHeight : window.innerHeight;

    // using Math.trunc to fix case if there is a difference in 0.5 pixels
    if (
      scrollTop &&
      Math.trunc(scrollTop + clientHeight + offsetScroll) > Math.trunc(scrollHeight)
    ) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  }, [node]);

  useEffect(() => {
    handleScroll();
  }, [location]);

  useEffect(() => {
    if (element) {
      element.addEventListener('scroll', handleScroll);

      return () => {
        element?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [element, handleScroll]);

  return { isBottom: debouncedIsBottom };
};
